import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ServiceListingsTab = () => {
  const [selectedListing, setSelectedListing] = useState(null);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [draggedItem, setDraggedItem] = useState(null);

  const serviceListings = [
  {
    id: 1,
    title: 'Professional Home Cleaning',
    provider: 'Clean Pro Services',
    category: 'Home Services',
    submissionDate: '2024-10-25',
    status: 'pending',
    price: '₹500/hr',
    location: 'Mumbai',
    thumbnail: "https://images.unsplash.com/photo-1649073005971-37babef31983",
    documents: ['Business License', 'Insurance Certificate', 'ID Proof'],
    complianceScore: 85,
    flaggedIssues: ['Missing insurance details']
  },
  {
    id: 2,
    title: 'Electrical Repair Services',
    provider: 'Spark Solutions',
    category: 'Repairs',
    submissionDate: '2024-10-24',
    status: 'under_review',
    price: '₹800/visit',
    location: 'Delhi',
    thumbnail: "https://images.unsplash.com/photo-1722903538739-ae86f93802d0",
    documents: ['Electrician License', 'Safety Certification'],
    complianceScore: 92,
    flaggedIssues: []
  },
  {
    id: 3,
    title: 'Plumbing Emergency Services',
    provider: 'Quick Fix Plumbers',
    category: 'Emergency Services',
    submissionDate: '2024-10-23',
    status: 'approved',
    price: '₹1200/call',
    location: 'Bangalore',
    thumbnail: "https://images.unsplash.com/photo-1709687854171-00a796554fcb",
    documents: ['Plumber License', 'Emergency Service Permit'],
    complianceScore: 98,
    flaggedIssues: []
  }];


  const statusColumns = [
  { id: 'pending', label: 'Pending Review', color: 'yellow' },
  { id: 'under_review', label: 'Under Verification', color: 'blue' },
  { id: 'approved', label: 'Approved', color: 'green' },
  { id: 'rejected', label: 'Rejected', color: 'red' }];


  const filteredListings = serviceListings?.filter((listing) => {
    if (filter !== 'all' && listing?.status !== filter) return false;
    if (searchQuery && !listing?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) &&
    !listing?.provider?.toLowerCase()?.includes(searchQuery?.toLowerCase())) return false;
    return true;
  });

  const getListingsByStatus = (status) => {
    return filteredListings?.filter((listing) => listing?.status === status);
  };

  const handleDragStart = (e, listing) => {
    setDraggedItem(listing);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, newStatus) => {
    e?.preventDefault();
    if (draggedItem && draggedItem?.status !== newStatus) {
      // Update listing status
      console.log(`Moving listing ${draggedItem?.id} to ${newStatus}`);
    }
    setDraggedItem(null);
  };

  const handleApprove = (listing) => {
    console.log('Approving listing:', listing?.id);
  };

  const handleReject = (listing) => {
    console.log('Rejecting listing:', listing?.id);
  };

  return (
    <div className="flex h-full">
      {/* Main Content */}
      <div className={`transition-all duration-300 ${selectedListing ? 'flex-1' : 'w-full'}`}>
        {/* Filters */}
        <div className="p-6 border-b border-border bg-card">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <Input
                placeholder="Search services or providers..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e?.target?.value)}
                className="w-full" />

            </div>
            <Select
              value={filter}
              onValueChange={setFilter}
              className="w-full sm:w-48">

              <option value="all">All Status</option>
              <option value="pending">Pending</option>
              <option value="under_review">Under Review</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </Select>
            <div className="flex gap-2">
              <Button variant="outline" size="sm">
                <Icon name="Filter" size={16} />
              </Button>
              <Button variant="outline" size="sm">
                Bulk Actions
              </Button>
            </div>
          </div>
        </div>

        {/* Kanban Board */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 h-full">
            {statusColumns?.map((column) =>
            <div
              key={column?.id}
              className="bg-muted/30 rounded-lg p-4 h-full"
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, column?.id)}>

                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-medium text-foreground">{column?.label}</h3>
                  <span className={`px-2 py-1 rounded text-xs font-medium bg-${column?.color}-100 text-${column?.color}-800`}>
                    {getListingsByStatus(column?.id)?.length}
                  </span>
                </div>

                <div className="space-y-3">
                  {getListingsByStatus(column?.id)?.map((listing) =>
                <div
                  key={listing?.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, listing)}
                  onClick={() => setSelectedListing(listing)}
                  className="bg-card border border-border rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow">

                      <div className="flex items-start gap-3">
                        <img
                      src={listing?.thumbnail}
                      alt={listing?.title}
                      className="w-12 h-12 rounded object-cover flex-shrink-0" />

                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm text-foreground truncate">
                            {listing?.title}
                          </h4>
                          <p className="text-xs text-muted-foreground truncate">
                            {listing?.provider}
                          </p>
                          <div className="flex items-center justify-between mt-2">
                            <span className="text-xs font-medium text-primary">
                              {listing?.price}
                            </span>
                            <span className="text-xs text-muted-foreground">
                              {listing?.location}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Compliance Score */}
                      <div className="mt-3 flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${
                      listing?.complianceScore >= 90 ? 'bg-green-500' :
                      listing?.complianceScore >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`
                      } />
                          <span className="text-xs text-muted-foreground">
                            {listing?.complianceScore}% compliant
                          </span>
                        </div>
                        <span className="text-xs text-muted-foreground">
                          {listing?.submissionDate}
                        </span>
                      </div>

                      {/* Quick Actions */}
                      {listing?.status === 'pending' &&
                  <div className="mt-3 flex gap-2">
                          <Button
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleApprove(listing);
                      }}>

                            <Icon name="Check" size={12} />
                            Approve
                          </Button>
                          <Button
                      variant="outline"
                      size="sm"
                      className="flex-1 h-8 text-xs"
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleReject(listing);
                      }}>

                            <Icon name="X" size={12} />
                            Reject
                          </Button>
                        </div>
                  }

                      {/* Flagged Issues */}
                      {listing?.flaggedIssues?.length > 0 &&
                  <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
                          <div className="flex items-center gap-1">
                            <Icon name="AlertTriangle" size={12} className="text-red-500" />
                            <span className="text-xs text-red-700">
                              {listing?.flaggedIssues?.length} issue(s)
                            </span>
                          </div>
                        </div>
                  }
                    </div>
                )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Detail Panel */}
      {selectedListing &&
      <div className="w-96 bg-card border-l border-border p-6 overflow-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">Service Details</h3>
            <Button
            variant="ghost"
            size="sm"
            onClick={() => setSelectedListing(null)}>

              <Icon name="X" size={16} />
            </Button>
          </div>

          <div className="space-y-6">
            {/* Service Info */}
            <div>
              <img
              src={selectedListing?.thumbnail}
              alt={selectedListing?.title}
              className="w-full h-32 object-cover rounded-lg" />

              <h4 className="font-medium text-foreground mt-3">
                {selectedListing?.title}
              </h4>
              <p className="text-sm text-muted-foreground">
                {selectedListing?.provider}
              </p>
            </div>

            {/* Compliance Checklist */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Compliance Status</h5>
              <div className="space-y-2">
                {selectedListing?.documents?.map((doc, index) =>
              <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-foreground">{doc}</span>
                    <Icon name="CheckCircle" size={16} className="text-green-500" />
                  </div>
              )}
              </div>
            </div>

            {/* Approval History */}
            <div>
              <h5 className="font-medium text-foreground mb-3">Approval History</h5>
              <div className="text-sm text-muted-foreground">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="Clock" size={12} />
                  Submitted on {selectedListing?.submissionDate}
                </div>
                <div className="flex items-center gap-2">
                  <Icon name="User" size={12} />
                  Assigned to Review Team
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <Button className="w-full">
                <Icon name="Check" size={16} />
                Approve Listing
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="X" size={16} />
                Reject Listing
              </Button>
              <Button variant="outline" className="w-full">
                <Icon name="MessageCircle" size={16} />
                Request Changes
              </Button>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default ServiceListingsTab;